import {types} from 'mobx-state-tree';
import request from '../services/http-request';
import KnownNotificationModel from '../models/known-notification-model';

const AllNotificationTypesStore = types

    .model('AllNotificationTypesStore', {
        types: types.optional(types.array(KnownNotificationModel), []),
    })
    .actions((self) => ({
        setTypes(data) {
            self.types = data;
        },
        init({email, password}) {
            (async () => {
                const response = await request({
                    method: 'get',
                    url: `notifications/types`,
                    noAuth: true,
                    auth: {username: email, password},
                });

                self.setTypes(response);
            })();
        },
    }));

export default AllNotificationTypesStore;

